import styled from 'styled-components';
import SVG from 'react-inlinesvg';
import LinkHandler from '../link-handler';
import { buttonStyles } from '../styled/buttons';

export const DownloadLink = styled(LinkHandler)`
  ${buttonStyles};
  text-align: left;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  display: flex;
  align-items: center;
`;

export const FileInfo = styled.div`
  font-size: 0.65em;
  display: inline-block;
  margin-right: ${({ theme }) => theme.spacing.tiny};

  &:last-child {
    margin-right: 0;
  }
`;

export const DownloadSVG = styled(SVG)`
  display: block;
  margin-right: ${({ theme }) => theme.spacing.small};
  fill: ${({ theme }) => theme.palette.white};
  flex-shrink: 0;
  width: 1em;
  height: 1em;
`;
